export default {
  createNewAccount: "Create new account!",
  alreadyAccount: "Already have an account?",
  signInstead: "Sign in instead",
  successFullyRegister: "You have successfully registered in to Bina"
}